import { memo } from "react";
import TipsTricksCard from "./tipsTricksCard";
import TipsTricksSkeleton from "./TipsTricksSkeleton";
import type { TipType, TipTitle } from "../types/tips";
import bgTop from "../Assets/Images/bg-top-blue.svg";
import bgBottom from "../Assets/Images/bg-bottom.png";

export interface TipsTricksProps {
  isLoading: boolean;
  allTips: TipType[];
  titles: TipTitle[];
  description: TipType[];
  typeId: string;
  descId: string;
  onTypeChange: (value: string) => void;
  onDescChange: (value: string) => void;
}

const TipsTricks = ({
  isLoading,
  allTips,
  titles,
  description,
  typeId,
  descId,
  onTypeChange,
  onDescChange,
}: TipsTricksProps) => {
  if (isLoading) {
    return <TipsTricksSkeleton />;
  }

  return (
    <div className="position-relative">
    <img className="bg-top d-none d-lg-block" src={bgTop} alt="" />
    <div className="container-xxl my-4">
      <p className="fw-bold mt-5 font-21">Checkout Useful Tips!</p>

      <div className="row mb-5">
        <div className="col-12 col-md-4 mb-2">
          <label className="font-14 mb-2">Type</label>
          <select
            value={typeId}
            onChange={(event) => onTypeChange(event.target.value)}
            className="form-select input_border_gray font-14 h-45px br-5px cursor-pointer"
            aria-label="Tip type"
          >
            <option value="0">All</option>
            {allTips.map((item) => (
              <option value={item.id} key={item.id}>
                {item.type}
              </option>
            ))}
          </select>
        </div>

        <div className="col-12 col-md-4">
          <label className="font-14 mb-2">Title</label>
          <select
            value={descId}
            onChange={(event) => onDescChange(event.target.value)}
            className="form-select input_border_gray font-14 h-45px br-5px cursor-pointer"
            aria-label="Tip title"
          >
            <option value="0">All</option>
            {titles.map((item) => (
              <option value={item.id} key={item.id}>
                {item.name}
              </option>
            ))}
          </select>
        </div>
      </div>
      {description.length === 0 &&
        <div className="col-12 text-center">
          <p className="text-red">No Record Found</p>
        </div>
      }
      {description.map((item) => (
        <div key={item.id}>
          {item.title.map((element) => (
            <TipsTricksCard key={element.id} data={element} />
          ))}
        </div>
      ))}
    </div>
    <img className="bg-bottom" src={bgBottom} alt="" />
  </div>
  );
};

export default memo(TipsTricks);
